import * as React from "react";
import { FullWidthForm, Label, Subtitle } from "./Styles/Styles";
export function SimpleTextPhase(_a) {
    var title = _a.title, _b = _a.titleColor, titleColor = _b === void 0 ? "currentColor" : _b, children = _a.children;
    return (React.createElement(FullWidthForm, { style: {
            flexGrow: 1,
            marginLeft: "20px",
            marginRight: "20px",
            marginTop: "20px",
        } },
        React.createElement("div", null,
            title ? (React.createElement(Subtitle, null,
                React.createElement("div", { className: "text-center text-2xl leading-normal", style: { color: titleColor } }, title))) : null,
            React.createElement("div", { className: "mt-[30px] self-stretch text-sm leading-normal" },
                React.createElement(Label, null,
                    React.createElement("div", null, children))))));
}
